var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lovemap-container-resize"},[_c('l-map',{ref:"map",staticClass:"love-map-canvas",attrs:{"zoom":_vm.zoomValue,"center":_vm.center,"options":{
                   zoomControl: false,
                   gestureHandling: true
            }},on:{"update:zoom":_vm.zoomUpdated,"update:center":_vm.centerUpdated}},[(_vm.isWebGlEnabled)?_c('TxTileLayer',{attrs:{"template-name":_vm.mapStyle}}):_c('l-tile-layer',{attrs:{"url":_vm.mapTileServer}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }